import * as React from "react";
import * as _ from 'lodash';
import { translate } from "react-i18next";
import { connect } from "react-redux";
// semantic
import { Dropdown, Icon, SemanticICONS, Table } from "semantic-ui-react";
import Button from "../../components/Button";
// components
import Dialog from "../../components/Dialogs/Dialog";
import { lang2flag } from '../../components/MultiLineColumn';
import TextField from "../../components/TextField";
import SelectField, { OptionValue } from "../../components/SelectField";
import { getIdentifierInputTypes, IdentifierInputType, sortOptionTypes } from "../../components/Table/dataHandler/Utils";
import { ITranslatedComponent } from "../../redux/reducers/generalReducer";
// services
import {
    ModelyearDto,
    OptionBasicDto,
    OptionBasicDtoOptionType,
    OptionBasicTextDto,
    CategoryTextDto,
    OptionTypes,
    PDiPOptionBasicDto,
    LanguageDto, UserDto, MenuDto
} from "../../services/Client";
import { createTexts, OptionBasicTextProp } from "./BaseOptionsTextUtils";
import OptionBasicRow from "./BaseOptionsRow";
import CategoryTextDropdown from "./CategoryTextDropdown";
import { RegexFactory } from "../../services/ColumnFactory";
import { renderErrorToast } from "../../utils/FeedbackMessageUtils";
import { compose } from "redux";
import {
    selectLanguageList,
    selectUserInfo,
    selectNonSerCategories,
    selectSerCategories,
    selectBaseOptionsAreaExtraLinks,
    selectClient
} from "../../redux/selectors";
import { IReduxState } from "src/redux/IReduxState";
import { LanguageCodeEnum } from "../AdminView/LanguageTab/LanguageTable";
import HATEOASClient, { Client, OptionCodeParam, OptionTypeParam } from "src/services/HATEOASClient";

interface IOwnProps {
    /** The model year for which to create the new DTO */
    modelyear: ModelyearDto;

    /** list containing all PDiP option basic data */
    allOptionBasicPDiPList: PDiPOptionBasicDto[];

    /** list containing filtered/unused PDiP option basic data */
    unusedOptionBasicPDiPList: PDiPOptionBasicDto[];

    /** The existing option basic row to provide initial values of the new option basic. */
    templateItem?: OptionBasicRow;

    /**
     * Called when the user clicks on create of new option basic
     * @param value new option basic to be created
     */
    onSave: (newDto: OptionBasicDto) => void;

    /** Cancel action */
    onCancel: () => void;

    resourceLinks:MenuDto | undefined;

}

interface IMapStateToProps {
    languageList?: LanguageDto[];
    userInfo?: UserDto;
    serCategories: CategoryTextDto[];
    nonSerCategories: CategoryTextDto[];
    baseOptionsAreaExtraLinks: MenuDto;
    client: HATEOASClient;
}

interface IOptionBasicCreationDialogProps extends IOwnProps, IMapStateToProps, ITranslatedComponent {

}

interface IOptionBasicCreationDialogState {
    /** Capture user input for OptionBasicDto.optionType. */
    optionType: OptionBasicDtoOptionType | undefined;

    /** Capture user input for OptionBasicDto. */
    optionCode: string | undefined;
    tempOptionCode: string | undefined;
    iconName: SemanticICONS | undefined;

    /** Capture user input for OptionBasicDto. */
    partNumber: string | undefined;

    /** Capture user input for OptionBasicDto. */
    comment: string | undefined;

    /** The texts for the new OptionBasicDto */
    texts: OptionBasicTextDto[];

    /** CategoryCode for the new OptionBasicDto */
    categoryCode: string | undefined;

    availableOptionTypes: any[];

    /** Type of input for option code */
    inputType: IdentifierInputType;
    isOptionTypeRequested: boolean;
    disableOptionType: boolean;
    optionTypes: any[];
    btnClass:string;
}

/**
 * The OptionBasicCreationDialog collects all necessary information for
 * creating a new OptionBasicDto. The component doesn't create the entity
 * in the database itself but passes a OptionBasicDto to it's client through
 * onClose() which is expected to call the back end API to create the DB entity.
 */
class OptionBasicCreationDialog extends React.Component<IOptionBasicCreationDialogProps, IOptionBasicCreationDialogState> {

    constructor(props: IOptionBasicCreationDialogProps) {
        super(props);

        const languages = props.languageList
            ? props.languageList.filter(dto => [LanguageCodeEnum.BASIC_GERMAN.toString(), LanguageCodeEnum.BASIC_ENGLISH.toString()].indexOf(dto.vmce) >= 0)
            : [];
        const userOptionTypes = props.userInfo && props.userInfo.optionTypes ? props.userInfo.optionTypes : [];

        // pre-selected row for copy
        const row = props.templateItem;

        let preselectedOptionType = undefined;
        // set pre-selected option type if a row was preselected and the user has rights
        if (row && userOptionTypes.find((ot: OptionTypes) => ot.toString() === row.optionType.toString())) {
            preselectedOptionType = row.optionType;
        }

        let categoryCode = undefined;
        if (preselectedOptionType) {
            if (row) {
                // set the category from the selected SER option
                categoryCode = row.category;
            }
        }

        this.state = {
            optionType: preselectedOptionType,
            optionCode: undefined,
            partNumber: row && row.partNumber,
            comment: row && row.comment,
            texts: createTexts(languages, row ? row.optionBasicDto.texts : undefined),
            categoryCode: categoryCode,
            availableOptionTypes: [],
            inputType: IdentifierInputType.MANUAL_INPUT,
            isOptionTypeRequested: false,
            optionTypes: [],
            disableOptionType: false,
            btnClass:'',
            iconName: 'arrow alternate circle down',
            tempOptionCode: undefined
        };
    }

    onClickCreate = (): void => {
        if (this.state.optionType === undefined || this.state.categoryCode === undefined) {
            // validation function failed
            renderErrorToast({
                message: "ERRORS:VALIDATION_ERROR",
                details: "ERRORS:CREATE_OB_VALIDATION",
                timestamp: Date.now()
            });
            return;
        }

        const category = this.state.categoryCode;
        const dummyCategoryText: CategoryTextDto = {
            categoryCode: "",
            languageId: 0,
            modelyearId: 0,
            objectId: 0,
            proMTSequence: 0,
            sequenceNo: 0,
            text: "",
            versionId: 0
        };
        if(this.state.optionCode && this.state.tempOptionCode && this.state.optionCode !== this.state.tempOptionCode) {
            this.onCancel();
        }
        this.props.onSave({
            modelyear: this.props.modelyear,
            category: category,
            categoryText: dummyCategoryText, // dummy obj for creation
            optionType: this.state.optionType,
            optionCode: this.state.optionCode ? this.state.optionCode.trim() : '',
            partNumber: this.state.partNumber,
            comment: this.state.comment,
            status: "",
            texts: this.state.texts,
            objectId: 0, // dummy objectId for creation
            versionId: 0, // dummy versionId for creation
            pccdCategoryOverride: false
        });
    }

    componentDidMount() {
        let availableOptionTypes: any[] = [];

        if (this.props.userInfo && this.props.userInfo.optionTypes) {
            this.props.userInfo.optionTypes.forEach(element => {
                availableOptionTypes.push(element);
            });
        }

        this.setState({ availableOptionTypes: availableOptionTypes });
    }

    renderTextControls = (): JSX.Element[] => (
        this.state.texts.map((text: OptionBasicTextDto, index: number) => {
            const flagPrefix = <i className={`${lang2flag(text.languageDto!.vmce)} flag`} />;
            return (
                <React.Fragment key={"texts_" + index}>
                    <Table.Row disabled={!this.state.isOptionTypeRequested}>
                        <Table.Cell className='width--200px'>{flagPrefix} {this.props.t("COLUMN_FACTORY:SHORTTEXT")}</Table.Cell>
                        <Table.Cell>{this.renderLanguageTextProp(index, "shorttext")}</Table.Cell>
                    </Table.Row>
                    <Table.Row disabled={!this.state.isOptionTypeRequested}>
                        <Table.Cell className='width--200px'>{flagPrefix} {this.props.t("COLUMN_FACTORY:LONGTEXT")}</Table.Cell>
                        <Table.Cell>{this.renderLanguageTextProp(index, "longtext")}</Table.Cell>
                    </Table.Row>
                </React.Fragment>
            );
        })
    )

    renderLanguageTextProp = (index: number, prop: OptionBasicTextProp): JSX.Element => (
        <TextField
            key={prop + "_" + index}
            multiLine={true}
            placeholder={this.props.t("COLUMN_FACTORY:" + prop.toUpperCase())}
            value={this.state.texts[index][prop]}
            id={`option-basic-${prop}-${index}`}
            onChange={(event: React.FormEvent<{}>, newValue: string) => {
                const newTexts = this.state.texts.slice();
                newTexts[index] = Object.assign({}, newTexts[index], { [prop]: newValue });
                this.setState({ texts: newTexts });
            }}
            errorText={this.getErrorText(prop.toUpperCase())}
        />
    )

    isValid = (): boolean => {
        return this.isOptionTypeValid() && //
            this.isCategoryValid() && //
            this.isOptionCodeValid() && //
            this.isPartNumberValid() && //
            this.areShorttextsValid();
    }

    isOptionTypeValid = (): boolean => {
        return (this.state.optionType !== undefined);
    }

    isCategoryValid = (): boolean => {
        return (this.state.categoryCode !== undefined);
    }

    isOptionCodeValid = (): boolean => {
        if (this.state.optionCode) {
            if (!this.state.optionCode.match(RegexFactory.regex.optionCode)) {
                return false;
            }
        }

        if (!this.state.optionCode && this.state.inputType !== IdentifierInputType.MANUAL_INPUT) {
            return false;
        }

        return true;
    }

    areShorttextsValid = (): boolean => {
        let shortTexts: string = '';
        _.forEach(this.state.texts, (text: OptionBasicTextDto) => {
            shortTexts = shortTexts + text.shorttext;
        });
        if (!shortTexts || shortTexts.length === 0) {
            return false;
        }
        return true;
    }

    isPartNumberValid = (): boolean => {
        if (this.state.optionType === OptionBasicDtoOptionType.TEQ) {
            if (!this.state.partNumber) {
                return false;
            }
        } else {
            if (this.state.partNumber) {
                return false;
            }
        }
        if (this.state.partNumber && !this.state.partNumber.match(RegexFactory.regex.partNumber)) {
            return false;
        }
        return true;
    }

    getErrorText = (fieldName: string): string | undefined => {
        let errorText: string | undefined;
        switch (fieldName) {
            case 'OPTION_CODE':
                if (!this.isOptionCodeValid()) {
                    errorText = this.props.t("ERRORS:OPTIONCODE_REGEX");
                }
                break;
            case 'PART_NUMBER':
                if (this.state.optionType === OptionBasicDtoOptionType.TEQ) {
                    if (!this.state.partNumber) {
                        errorText = this.props.t("ERRORS:PARTNUMBER_REGEX");
                    }
                } else {
                    if (this.state.partNumber) {
                        errorText = this.props.t("ERRORS:PARTNUMBER_REGEX_2");
                    }
                }
                if (this.state.partNumber && !this.state.partNumber.match(RegexFactory.regex.partNumber)) {
                    errorText = this.props.t("ERRORS:PARTNUMBER_REGEX_3");
                }
                break;
            case 'SHORTTEXT':
                if (!this.areShorttextsValid()) {
                    errorText = this.props.t("ERRORS:SHORTTEXT_REGEX");
                }
                break;
            default:
        }
        return errorText;
    }

    private getPDiPOptionCodeRenderKey = (pOB: PDiPOptionBasicDto) => {
        return pOB.optionCode.trim() + ' (' + pOB.shorttextDe + ')';
    }

    renderInputTypeSelection = (): JSX.Element => (
        <Dropdown
            id={'new-option-basic-input-type-selection'}
            clearable={false}
            closeOnChange={true}
            selection={true}
            icon={
                <Icon
                    name={this.state.inputType === IdentifierInputType.MANUAL_INPUT ? 'keyboard'
                        : this.state.inputType === IdentifierInputType.ALL_PDIP_DS_INPUT ? 'database' : 'filter'}
                    style={{ float: 'left' }}
                />
            }
            options={getIdentifierInputTypes()}
            value={this.state.inputType}
            onChange={(e, v) => {
                const newTexts = this.state.texts.slice();
                const index = newTexts.findIndex((txt) => txt.languageDto !== undefined && txt.languageDto.code === 'de');
                newTexts[index] = Object.assign({}, newTexts[index], { ["shorttext"]: '' });

                this.setState({
                    inputType: v.value as IdentifierInputType,
                    optionCode: undefined,
                    texts: newTexts
                });
            }}
        />
    )

    renderPDiPDropdown = () => (
        <div style={{ flex: 'auto' }}>
            <SelectField
                searchable={true}
                clearable={true}
                autoEscape={true}
                placeholder={this.props.allOptionBasicPDiPList.length === 0
                    || (this.state.inputType === IdentifierInputType.UNUSED_PDIP_DS_INPUT && this.props.unusedOptionBasicPDiPList.length === 0)
                    ? this.props.t("EMPTY_PDIP_SELECTION") : this.props.t("SELECT_PDIP_OPTION_CODE")}
                dataSource={this.state.inputType === IdentifierInputType.ALL_PDIP_DS_INPUT
                    ? this.props.allOptionBasicPDiPList : this.props.unusedOptionBasicPDiPList}
                value={this.state.optionCode}
                valueComparator={(actual: PDiPOptionBasicDto, expected: string) => actual.optionCode === expected}
                rendererKey={this.getPDiPOptionCodeRenderKey}
                filterOption={(pOB: PDiPOptionBasicDto, filter: string) =>
                    this.getPDiPOptionCodeRenderKey(pOB).toUpperCase().includes(filter.toUpperCase())}
                onChange={(value?: PDiPOptionBasicDto) => {

                    const newTexts = this.state.texts.slice();
                    const index = newTexts.findIndex((txt) => txt.languageDto !== undefined && txt.languageDto.code === 'de');
                    newTexts[index] = Object.assign({}, newTexts[index], { ["shorttext"]: value ? value.shorttextDe : '' });

                    this.setState({
                        optionCode: value ? value.optionCode : undefined,
                        texts: newTexts,
                        btnClass:'default_btn',
                        iconName: 'arrow alternate circle down',
                    });
                }}
            />
        </div>
    )

    onClickGetOptionType = () => {
        if(!this.state.optionCode && this.state.tempOptionCode) {
            this.setState({optionCode:this.state.tempOptionCode});
            return;
        }
        if(this.state.optionCode && this.state.optionCode === this.state.tempOptionCode) {
            return;
        }
        if(this.state.optionCode && this.state.optionCode.includes('#')) {
            this.setState({optionCode:this.state.tempOptionCode});
            return;
        }

        this.setState({ isOptionTypeRequested: true, btnClass: 'request_btn', iconName: 'wait' });
        const { resourceLinks, client } = this.props;
        const param: OptionTypeParam = {
            modelyear: this.props.modelyear.objectId,
            optionCode: this.state.optionCode || ''
        };

        if (resourceLinks) {
            client.GET_optionBasicOptionType(resourceLinks).execute(param).then((data: any) => {
                if (!this.state.optionCode && data && data.tempOptionCode && !this.state.tempOptionCode) {
                    this.setState({ tempOptionCode: data.tempOptionCode });
                }
                if (data && data.optionType) {
                    this.setState({
                        optionTypes: [data.optionType],
                        optionCode: data.tempOptionCode,
                        disableOptionType: true,
                        optionType: data.optionType as OptionBasicDtoOptionType,
                        btnClass: 'request_btn',
                        iconName: 'arrow alternate circle down',
                    });
                } else {
                    this.setState({
                        optionTypes: this.state.availableOptionTypes,
                        optionCode: data.tempOptionCode,
                        disableOptionType: false,
                        btnClass: 'not_data_found',
                        iconName: 'unlink',
                    });
                }
            });
        }
    }

    onCancel = () => {
        const { resourceLinks, client } = this.props;
        if (resourceLinks && this.state.tempOptionCode) {
            const param: OptionCodeParam = {
                optionCode: this.state.tempOptionCode.replace('#','') // In query string # is not passed so need to remove it from here and appeand it on BE side
            };
            client.GET_setInactiveOptionCode(resourceLinks).execute(param);
        }
        this.props.onCancel();
    }

    render() {

        const actions = [
            <Button key={1} id="ob_create" icon={"checkmark"} disabled={!this.isValid()} onClick={this.onClickCreate} />,
            <Button key={2} icon={"ban"} onClick={this.onCancel} />
        ];

        return (
            <Dialog
                title={this.props.templateItem ? this.props.t("BASEOPTIONS:COPY_OPTION_BASIC") : this.props.t("NEW_OPTION_BASIC")}
                open={true}
                actions={actions}
                fullWidth={false}
                customStyleClassName={"CreateOBDialog"}
            >
                <Table definition={true}>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell className='width--200px'>{this.props.t("COLUMN_FACTORY:OPTIONCODE")}</Table.Cell>
                            <Table.Cell className={'display--flex align-items--center'}>
                                {this.state.inputType === IdentifierInputType.MANUAL_INPUT ?
                                    <TextField
                                        id="option_code"
                                        placeholder={this.props.t("COLUMN_FACTORY:OPTIONCODE")}
                                        value={this.state.optionCode}
                                        onChange={(event: React.FormEvent<{}>, newValue: string) => {
                                            this.setState({ optionCode: newValue,  iconName:'arrow alternate circle down',btnClass:'default_btn' });
                                        }}
                                        errorText={this.getErrorText('OPTION_CODE')}
                                    />
                                    :
                                    this.renderPDiPDropdown()
                                }
                                {this.renderInputTypeSelection()}
                                <Button
                                    key={1}
                                    id="get_option_type"
                                    icon={this.state.iconName}
                                    className={this.state.btnClass}
                                    onClick={this.onClickGetOptionType}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row disabled={!this.state.isOptionTypeRequested}>
                            <Table.Cell className='width--200px'>{this.props.t("OPTION_TYPE")}*</Table.Cell>
                            <Table.Cell>
                                <SelectField
                                    id="option-type-select"
                                    placeholder={this.props.t("OPTION_TYPE")}
                                    searchable={true}
                                    disabled={this.state.disableOptionType}
                                    clearable={false}
                                    dataSource={this.state.optionTypes ? this.state.optionTypes.sort(sortOptionTypes) : []}
                                    value={this.state.optionType}
                                    rendererKey={(value: OptionBasicDtoOptionType) => this.props.t("GLOBAL:" + value) + " (" + value + ')'}
                                    onChange={(selectedValue?: OptionValue) => {
                                        const value = selectedValue ? OptionBasicDtoOptionType[selectedValue as string] : undefined;
                                        this.setState({
                                            optionType: value,
                                            categoryCode: undefined,
                                            partNumber: this.state.optionType === value && value === OptionBasicDtoOptionType.TEQ ? this.state.partNumber : undefined
                                        });
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row disabled={!this.state.isOptionTypeRequested}>
                            <Table.Cell className='width--200px'>{this.props.t("CATEGORY")}*</Table.Cell>
                            <Table.Cell>
                                <CategoryTextDropdown
                                    id="category-select"
                                    modelyear={this.props.modelyear}
                                    placeholder={this.props.t("CATEGORY")}
                                    categories={this.state.optionType === undefined ? []
                                        : this.state.optionType === OptionBasicDtoOptionType.SER
                                            ? this.props.serCategories
                                            : this.props.nonSerCategories}
                                    value={this.state.categoryCode}
                                    onChange={(value) => {
                                        this.setState({
                                            categoryCode: value
                                        });
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>

                        {this.state.optionType === OptionBasicDtoOptionType.TEQ &&
                            <Table.Row disabled={!this.state.isOptionTypeRequested}>
                                <Table.Cell className='width--200px'>{this.props.t("PART_NUMBER")}</Table.Cell>
                                <Table.Cell>
                                    <TextField
                                        placeholder={this.props.t("PART_NUMBER")}
                                        value={this.state.partNumber}
                                        onChange={(event: React.FormEvent<{}>, newValue: string) => this.setState({ partNumber: newValue })}
                                        errorText={this.getErrorText('PART_NUMBER')}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        }
                        {this.renderTextControls()}
                        <Table.Row disabled={!this.state.isOptionTypeRequested}>
                            <Table.Cell className='width--200px'>{this.props.t("COMMENT")}</Table.Cell>
                            <Table.Cell>
                                <TextField
                                    placeholder={this.props.t("COMMENT")}
                                    value={this.state.comment}
                                    onChange={(event: React.FormEvent<{}>, newValue: string) => this.setState({ comment: newValue })}
                                    errorText={this.getErrorText('COMMENT')}
                                />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
                <div>* {this.props.t("MANDATORY_FIELD")}</div>
            </Dialog>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    languageList: selectLanguageList(state),
    userInfo: selectUserInfo(state),
    serCategories: selectSerCategories(state),
    nonSerCategories: selectNonSerCategories(state),
    baseOptionsAreaExtraLinks: selectBaseOptionsAreaExtraLinks(state),
    client: selectClient(state),
});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["BASEOPTIONS", "COLUMN_FACTORY"]),
    connect<IMapStateToProps>(mapStateToProps)
)(OptionBasicCreationDialog);



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/OptionBasicCreationDialog.tsx